import { useMemo, useState } from "react";
import { CalcStore } from "./CalcStore";
import analytics from "../../analytics";
import utils from "../../mixins/utils";

const CalcStoreProvider = ({ children }) => {
  const [calcData, setCalcData] = useState({
    year: "2024",
    productUnitsType: "acre",
    step1Seeds: [{ id: "0", product_type: "seed" }], // portfolio (seed only)
    step1Herbicides: [{ id: "0", product_type: "herbicide" }], // portfolio (herbicide only)
    step1Fungicides: [{ id: "0", product_type: "fungicide" }], // portfolio (fungicide only)
    step1Insecticides: [{ id: "0", product_type: "insecticide" }], // portfolio (insecticide only)
    step1Nematicides: [{ id: "0", product_type: "nematicide" }], // portfolio (nematicide only)
    step1PairSeeds: {}, // pair products groups (seed only)
    step1PairHerbicides: {}, // pair products groups (herbicide only)
    step1PairFungicides: {}, // pair products groups (fungicide only)
    step1PairInsecticides: {}, // pair products groups (insecticide only)
    step1PairNematicides: {}, // pair products groups (nematicide only)
    step2Roundup: [{ id: "0", product_type: "roundup" }], // step 2 Roundup selection
    step2Xtendimax: [{ id: "0", product_type: "xtendimax" }], // step 2 optional XtendiMax
    step3Products: [{ id: "0", product_type: "additional" }], // additional products
    step4Products: [{ id: "0", product_type: "partner" }], // partner products
    loyaltyRewardsToRetailer: 0,
    comments: "",
  });

  const changeCalcData = (state, values, paired = false) => {
    const isPaired = state.indexOf("Pair") > -1;

    const key =
      paired && !isPaired
        ? state.slice(0, utils.findindex(state) + 1) +
          "Pair" +
          state.slice(utils.findindex(state) + 1)
        : state;
    let updatedValues = {
      [state]: values,
    };
    if (paired) {
      updatedValues = {
        [key.split("Pair").join("")]: [],
        [key]: {
          ...calcData[key],
          [values[0].paired]: values,
        },
      };
    }

    setCalcData({
      ...calcData,
      ...updatedValues,
    });
  };

  const addProduct = (state, index, productType) => {
    const data = [...calcData[state]];
    data.push({ id: index.toString() });
    setCalcData({
      ...calcData,
      [state]: data,
    });

    /** FOR ANALYTICS */
    let productTypeUpper =
      utils.stepNumber(productType) === "3"
        ? "Agronomic"
        : utils.titleCase(productType);
    let stepNumber = utils.stepNumber(productType);

    analytics.dataPush(
      analytics.constructObj(
        "Click - Add Row",
        `Step ${stepNumber} - ${productTypeUpper} Products`
      )
    );
  };

  const deleteProduct = (state, index, productType, pairedId) => {
    const isPaired = pairedId && calcData[state][pairedId];
    let data;

    if (isPaired) {
      data = [...calcData[state][pairedId]];
    } else {
      data = [...calcData[state]];
    }

    data.splice(index, 1);
    let updatedValues = {
      [state]: data,
    };

    if (isPaired && data.length > 1) {
      updatedValues = {
        [state.split("Pair").join("")]: [],
        [state]: {
          ...calcData[state],
          [data[0].paired]: data,
        },
      };
    } else if (isPaired) {
      updatedValues = {
        [state.split("Pair").join("")]: data,
        [state]: {},
      };
    }

    setCalcData({
      ...calcData,
      ...updatedValues,
    });

    /** FOR ANALYTICS */
    let isXtendimax = productType === "xtendimax";

    let stepNumber = isXtendimax ? "2" : utils.stepNumber(productType);
    let productTypeUpper = isXtendimax
      ? "Xtendimax"
      : stepNumber === "3"
      ? "Agronomic"
      : utils.titleCase(productType);

    analytics.dataPush(
      analytics.constructObj(
        "Click - Remove Row",
        `Step ${stepNumber} - ${productTypeUpper} Products`
      )
    );
  };

  const [total, setTotal] = useState(0);

  return (
    <CalcStore.Provider
      value={useMemo(
        () => ({
          calcData,
          changeCalcData,
          setCalcData,
          addProduct,
          deleteProduct,
          total,
          setTotal,
        }),
        [calcData, total]
      )}
    >
      {children}
    </CalcStore.Provider>
  );
};

export default CalcStoreProvider;
